export default __webpack_public_path__ + "static/media/pic49.57aff7a4.JPG";